export default (phoneNumber) => {
  if (phoneNumber) {
    // Remove all characters other than digits and `+`
    const badCharacterPattern = /[^+\d]/g;
    const numbers = phoneNumber.replace(badCharacterPattern, '');
    // It is valid if the stripped string starts with +614, +615, 04 or 05 and followed by 8 digits
    const validMobilePhoneNumberPattern = /^(\+61|0)[45]\d{8}\b/;
    return validMobilePhoneNumberPattern.test(numbers);
  }
  return false;
};
